import * as S from "./styles";
import P from "prop-types";

export function TabMenu({ currentIndex, setIndex }) {
  return (
    <S.Container>
      <S.Container2>
        <S.Button
          onClick={() => {
            setIndex(1);
          }}
          selected={currentIndex === 1}
        >
          SENTIMENTOS
        </S.Button>
        <S.Button
          onClick={() => {
            setIndex(2);
          }}
          selected={currentIndex === 2}
        >
          SATISFAÇÃO
        </S.Button>
      </S.Container2>
    </S.Container>
  );
}

TabMenu.propTypes = {
  currentIndex: P.number,
  setIndex: P.func,
};
